<app-dialog id="build-deal" [title]="'viewVehicleProfile.buildDeal.title' | translate" [isValid]="formGroup.valid"
  [confirmation]="'viewVehicleProfile.buildDeal.confirmation' | translate" (save)="onSave()">
  <p>{{ 'viewVehicleProfile.buildDeal.description' | translate }}</p>
  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col-6">
        <mat-label>{{ 'viewVehicleProfile.buildDeal.form.firstName' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="firstName" track="Inventory, build_deal_first_name">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-label>{{ 'viewVehicleProfile.buildDeal.form.lastName' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="lastName" track="Inventory, build_deal_last_name">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-label>{{ 'viewVehicleProfile.buildDeal.form.emailAddress' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="emailAddress" track="Inventory, build_deal_email">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-label>{{ 'viewVehicleProfile.buildDeal.form.phoneNumber' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput appPhoneNumber type="tel" formControlName="phoneNumber" [value]="formGroup.get('phoneNumber')?.value | phone" [placeholder]="'viewVehicleProfile.buildDeal.form.phoneNumber' | translate"  track="Inventory, build_deal_email">
        </mat-form-field>
      </div>
    </div>
  </form>
</app-dialog>